import React from "react";
import {
  FooterWrapper,
  FooterContent,
  FooterSection,
  FooterBottom,
  SocialMedia,
  SocialLink,
  CompanyInfo,
  LogoContainer,
} from "./Footer.styles";

import {
  FaFacebookF,
  FaInstagram,
  FaYoutube,
  FaPhone,
  FaEnvelope,
} from "react-icons/fa";

import { ReactComponent as Logo } from "../../assets/icons/logoMrc.svg";

const Footer = () => {
  return (
    <FooterWrapper>
      <div className="container">
        <FooterContent>
          <FooterSection>
            <LogoContainer>
              <Logo width={200} height={200} />
            </LogoContainer>

            <CompanyInfo>
              <p>Zvanični МРЧ. Originalni proizvodi, premium kvalitet.</p>
            </CompanyInfo>
          </FooterSection>

          <FooterSection>
            <h3>Navigacija</h3>
            <ul>
              <li>
                <a href="/">Početna</a>
              </li>
              <li>
                <a href="/prodavnica">Prodavnica</a>
              </li>
              <li>
                <a href="/bendovi">Bendovi</a>
              </li>
              <li>
                <a href="/novosti">Novosti</a>
              </li>
              <li>
                <a href="/o-nama">O nama</a>
              </li>
            </ul>
          </FooterSection>

          <FooterSection>
            <h3>Kontakt</h3>
            <div className="contact-info">
              <div className="contact-item">
                <FaPhone />
                <span>+381 34 123 4567</span>
              </div>
              <div className="contact-item">
                <FaEnvelope />
                <span>info@mrc.rs</span>
              </div>
            </div>
          </FooterSection>

          <FooterSection>
            <h3>Pratite nas</h3>
            <p>Budite u toku sa najnovijim vestima i proizvodima</p>
            <SocialMedia>
              <SocialLink
                title="USKORO"
                // href="https://facebook.com"
                // target="_blank"
                // rel="noopener noreferrer"
              >
                <FaFacebookF />
              </SocialLink>
              <SocialLink
                title="@mrc.srbija"
                href="https://www.instagram.com/mrc.srbija/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaInstagram />
              </SocialLink>
              <SocialLink title="USKORO">
                <FaYoutube />
              </SocialLink>
            </SocialMedia>
          </FooterSection>
        </FooterContent>

        <FooterBottom>
          <p>© 2024 МРЧ. Sva prava zadržana.</p>
        </FooterBottom>
      </div>
    </FooterWrapper>
  );
};

export default Footer;
